import { Validators } from '@angular/forms';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { notWhitespaceValidator } from '@utility/utility.validators';

export class SingleStipendVisitFormGroup extends PersistentFormGroup<{
    hasStipend: PersistentFormControl<boolean | null>;
    amount: PersistentFormControl<number | null>;
}> {
    constructor() {
        super({
            hasStipend: new PersistentFormControl<boolean | null>(null),
            amount: new PersistentFormControl<number | null>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(-1e6),
                Validators.max(1e6),
            ]),
        });
    }
}
